import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QaiFloatingSelectComponent, QaiMultiSelectComponent, QaiLabelComponent, QaiAccountSelectorComponent } from '@qai/ui';
import { TranslationService } from 'src/app/services/translation.service';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { ICustomerAccountPayload } from 'src/app/interfaces/reportingV2/icustomer-account-payload';
import { AccountOption } from 'src/app/interfaces/self-serve/iaccounts-by-customer';
import { EntityOption } from 'src/app/interfaces/reportingV2/ientity-option';
@Component({
  selector: 'app-account-team-selector',
  templateUrl: './account-team-selector.component.html',
  styleUrls: ['./account-team-selector.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    QaiFloatingSelectComponent,
    QaiMultiSelectComponent,
    QaiLabelComponent,
    QaiAccountSelectorComponent,
    TranslocoModule
  ]
})
export class AccountTeamSelectorComponent {
  @Input() accountOptions: AccountOption[] = [];
  @Input() selectedAccount: AccountOption | null = null;
  @Input() teamOptions: EntityOption[] = [];
  @Input() selectedTeams: string[] = [];
  @Input() isLoadingAccounts = false;
  @Input() isLoadingTeams = false;
  @Input() multipleCustomers: ICustomerAccountPayload[] = [];

  @Output() accountChange = new EventEmitter<any>();
  @Output() teamChange = new EventEmitter<string[]>();
  isTranslationLoaded = false;
  clearOption = { enable: true, label: 'Clear teams' };
  visibleOptionsMode = {
    enable: true,
    selectAllOption: { value: 'selectAll', label: 'Select all' },
    deselectAllOption: { value: 'deselectAll', label: 'Deselect all' }
  };

  constructor(private translationService: TranslationService,
    private translocoService: TranslocoService
  ) {
  }
  ngOnInit(): void {
    this.translationService.loadScopedTranslation('reportingV2').then(() => {
      this.isTranslationLoaded = true;
      this.clearOption.label = this.translocoService.translate(
        'CLEAR_TEAMS',
        {},
        'reportingV2'
      );
      this.visibleOptionsMode.selectAllOption.label = 
        this.translocoService.translate('SELECT_ALL', {}, 'reportingV2');
      this.visibleOptionsMode.deselectAllOption.label = 
        this.translocoService.translate( 'DESELECT_ALL', {}, 'reportingV2');
    });

  }

  onAccountChange(selectedValue: any): void {
    console.log('Selected Account Value:', selectedValue);
    this.accountChange.emit(selectedValue);
  }

  onTeamChange(selectedValues: string[]): void {
    this.teamChange.emit(selectedValues);
  }
} 